import { AuthContext, ConferenceContext } from '@/store';
import { useContext, useMemo } from 'react';

export const useLinkAction = () => {
  const { openUserPopup, openNewThreadPopup } = useContext(ConferenceContext);
  const { authState } = useContext(AuthContext);

  const linkActionCall = useMemo(
    () => (item: any, urlMethod: 'to' | 'href' = 'to') => {
      // console.log('item', item);
      const ACTION_STRING = 'action:';
      if (item.url.startsWith(ACTION_STRING)) {
        const [action, param] = item.url
          .substr(ACTION_STRING.length)
          .split(':');

        if (!authState.userLoggedIn) {
          return {
            onClick: (e: any) => {
              e.preventDefault();
              console.log('not logged in!', action);
              return false;
            },
          };
        }
        switch (action) {
          case 'userpopup': {
            return {
              onClick: (e: any) => {
                e.preventDefault();
                openUserPopup({ id: param, full_name: 'Loading...' });
                return false;
              },
            };
          }
          case 'userdm': {
            return {
              onClick: (e: any) => {
                e.preventDefault();
                openNewThreadPopup([], 'center', param);
                return false;
              },
            };
          }
        }
        return {
          onClick: (e: any) => {
            e.preventDefault();
            console.log('action', action);
            return false;
          },
        };
      } else {
        // Check if URL is external (starts with http:// or https://)
        const isExternalUrl =
          item.url &&
          (item.url.startsWith('http://') || item.url.startsWith('https://'));

        // For external URLs, use href instead of to (React Router Link doesn't support external URLs in pathname)
        if (isExternalUrl) {
          return {
            href: item.url,
            target: item.target == '_blank' ? '_blank' : '_self',
            rel: item.target == '_blank' ? 'noopener noreferrer' : undefined,
          };
        }

        // For internal URLs, use the appropriate method
        return {
          [urlMethod]: urlMethod === 'to' ? { pathname: item.url } : item.url,
          target: item.target == '_blank' ? '_blank' : '_self',
        };
      }
    },
    []
  );

  return {
    linkActionCall,
  };
};
